import React, { useEffect, useState, Fragment } from 'react';
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
type CountdownProps = {
  /** total seconds to count down from */
  initialSeconds?: number;
  variant?: 'block' | 'inline';
};
export function Countdown({
  initialSeconds = 23 * 3600 + 42 * 60 + 41,
  variant = 'block'
}: CountdownProps) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s <= 0 ? 0 : s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  if (variant === 'inline') {
    return <span className="font-display tracking-wide text-gold" aria-live="polite" data-id="element-55">
        {h} heures : {pad(m)} min : {pad(s)} secondes
      </span>;
  }
  const units = [{
    value: h,
    label: 'heures'
  }, {
    value: m,
    label: 'min'
  }, {
    value: s,
    label: 'sec'
  }];
  return <div className="flex items-center justify-center gap-3 sm:gap-4" aria-live="polite" data-id="element-56">
      {units.map((u, i) => <Fragment key={u.label} data-id="element-57">
          <div className="flex flex-col items-center" data-id="element-58">
            <div className="min-w-[64px] rounded-xl border border-ink-border bg-ink-card px-3 py-3 sm:min-w-[84px] sm:px-5 sm:py-4" data-id="element-59">
              <span className="font-display text-3xl leading-none text-gold sm:text-5xl" data-id="element-60">
                {pad(u.value)}
              </span>
            </div>
            <span className="mt-2 text-xs font-semibold uppercase tracking-widest text-white/50" data-id="element-61">
              {u.label}
            </span>
          </div>
          {i < units.length - 1 && <span className="font-display text-2xl text-white/30 sm:text-4xl" data-id="element-62">
              :
            </span>}
        </Fragment>)}
    </div>;
}